import { Grid, Paper } from '@mui/material'
import { styled } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import apiFunctions from '../../api/apiFunctions';
import Toptag from '../../components/toptag/Toptag'
import Loader from '../../components/Loader/Loader'

const BackPaper = styled(Paper)({
    minHeight: "calc(100vh - 130px)",
    borderRadius: "0",
    padding: "20px",
    overflow: "visible",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

const SuggestionDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [obj, setObj] = useState({})

    const getDetail = async () => {
        const result = await apiFunctions.getSuggestionDetail(location.state.id);
        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            setIsLoading(false)
        } else {
            setObj(result.data.data)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (!location.state || !location.state.id) { navigate('/home/suggestions'); return; }
        getDetail()
    }, [])

    const isExisting = obj.suggestion_type === 'existing';
    const coords = obj.location?.coordinates || [];
    const latitude = coords.length >= 2 ? coords[1] : '';
    const longitude = coords.length >= 2 ? coords[0] : '';

    return (
        <>
            <ToastContainer autoClose={1000} />
            {isLoading ?
                <Loader />
                :
                <>
                    <Toptag />
                    <BackPaper>
                        <h3>Suggestion</h3>
                        <hr />
                        <Grid container spacing={2}>
                            <Grid xs={12} sm={12} md={6} lg={6} item>
                                <Grid container spacing={3} direction="column">
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div className="popText">Suggested By</div>
                                        <input type="text" className="popInput1" value={obj.user?.user_name || ''} readOnly />
                                    </Grid>
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div className="popText">Type</div>
                                        <input type="text" className="popInput1" value={isExisting ? 'Existing Event Change' : 'New Event'} readOnly />
                                    </Grid>
                                    {isExisting ? (
                                        <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                            <div className="popText">Source ID</div>
                                            <input type="text" className="popInput1" value={obj.source_id || ''} readOnly />
                                        </Grid>
                                    ) : (
                                        <>
                                            <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                                <div className="popText">Address</div>
                                                <input type="text" className="popInput1" value={obj.address || ''} readOnly />
                                            </Grid>
                                            <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                                <div className="popText">Country</div>
                                                <input type="text" className="popInput1" value={obj.country || ''} readOnly />
                                            </Grid>
                                        </>
                                    )}
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div className="popText">Description</div>
                                        <textarea className="popInput1" value={obj.description || ''} style={{ height: "200px" }} readOnly />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid xs={12} sm={12} md={6} lg={6} item>
                                <Grid container spacing={3} direction="column">
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div className="popText">Suggested By Email</div>
                                        <input type="text" className="popInputeventDetail" value={obj.user?.email || ''} readOnly />
                                    </Grid>
                                    {!isExisting && (
                                        <>
                                            <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                                <div className="popText">Latitude</div>
                                                <input type="text" className="popInputeventDetail" value={latitude} readOnly />
                                            </Grid>
                                            <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                                <div className="popText">Longitude</div>
                                                <input type="text" className="popInputeventDetail" value={longitude} readOnly />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </BackPaper>
                </>}
        </>
    )
}

export default SuggestionDetail
